import React, { Component, ReactNode } from 'react';

import { initialise, logError } from './IwDataDogLogger';
import { ManuallyLocalisedFallbackError } from './ManuallyLocalisedFallbackError';
import { isDevelopmentEnv } from '../devOpsHelper/DevOps';

export class IwLogger extends Component<
    { children: ReactNode },
    { hasError: boolean }
> {
    state = { hasError: false };

    componentDidMount() {
        if (!isDevelopmentEnv()) {
            initialise();
        }
    }

    componentDidCatch(error: Error, info: React.ErrorInfo) {
        this.setState({ hasError: true });

        if (isDevelopmentEnv()) {
            console.error('Reported Error', error);
        } else {
            logError(
                error.message,
                {
                    tags: {
                        reporter: 'catch_component'
                    },
                    info
                },
                error
            );
        }
    }

    render() {
        if (this.state.hasError) {
            return <ManuallyLocalisedFallbackError />;
        }

        return this.props.children;
    }
}
